export const getHTMLEmitirAlerta = (erros) => {
	let html = '<p>As seguintes etapas estão com campos obrigatórios não preenchidos: </p>';

	html += '<ul >';

	for (let index = 0; index < erros.length; index++) {
		const element = erros[index];
		html += `<li >${element.message}</li>`;
	}

	html += '</ul>';

	return html;
};
